var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},[_c('ul',_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[(link.href && index < _vm.links.length - 1)?_c('NuxtLink',{attrs:{"to":link.href}},[_vm._v("\n        "+_vm._s(link.name)+"\n      ")]):_c('span',[_vm._v(_vm._s(link.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }